import { type IApiResponse, type IElectionOfficialByIDState, type IElectionOfficialData } from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';
import { type ICreateElectionOfficial, type IUpdateElectionOfficial } from '@/store/actions/core/election-official';

import { coreApiSlice } from '../apiSlice';

const electionOfficialApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createElectionOfficial: builder.mutation<IApiResponse, ICreateElectionOfficial>({
			query: (body) => ({
				url: '/ElectionOfficial',
				method: 'POST',
				body,
			}),
		}),
		createBulkElectionOfficial: builder.mutation<IApiResponse, ICreateElectionOfficial[]>({
			query: (body) => ({
				url: '/ElectionOfficial/bulk-assignment',
				method: 'POST',
				body,
			}),
		}),
		getElectionOfficial: builder.query({
			query: () => ({
				url: '/ElectionOfficial',
			}),
		}),
		getElectionOfficialById: builder.query<IApiResponse<IElectionOfficialByIDState>, { id: string }>({
			query: ({ id }) => ({
				url: `/ElectionType/${id}`,
			}),
		}),
		updateElectionOfficial: builder.mutation<IApiResponse, { id: string; data: IUpdateElectionOfficial }>({
			query: ({ id, data }) => ({
				method: 'PUT',
				url: `/ElectionOfficial/update/${id}`,
				body: data,
			}),
		}),
		deleteElectionOfficial: builder.mutation<IApiResponse, { id: number }>({
			query: ({ id }) => ({
				url: `/ElectionOfficial/delete/${id}`,
				method: 'DELETE',
			}),
		}),
		updateElectionOfficialStatus: builder.mutation<IApiResponse, { id: string; data: { isCompleted: boolean } }>({
			query: ({ id, data }) => ({
				method: 'PUT',
				url: `/ElectionOfficial/update-status/${id}`,
				body: data,
			}),
		}),
		electionOfficialFilterby: builder.query<IApiResponse<IElectionOfficialData[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/ElectionOfficial/filter${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
	}),
});

export const {
	useCreateBulkElectionOfficialMutation,
	useCreateElectionOfficialMutation,
	useDeleteElectionOfficialMutation,
	useElectionOfficialFilterbyQuery,
	useLazyElectionOfficialFilterbyQuery,
	useGetElectionOfficialByIdQuery,
	useGetElectionOfficialQuery,
	useLazyGetElectionOfficialByIdQuery,
	useLazyGetElectionOfficialQuery,
	useUpdateElectionOfficialMutation,
	useUpdateElectionOfficialStatusMutation,
} = electionOfficialApiSlice;
